"use client";

import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import getLegacyTheme from "@/theme/legacy-wrapped-theme";
import {MarketName} from "@/types/market-context/market-context";

interface LegacyThemeProviderProps {
  children: React.ReactNode;
  market?: MarketName;
}

/**
 * Provides legacy Bootstrap-style breakpoints to child components.
 * 
 * Use this provider when you need to support legacy breakpoints like:
 * - zero (0px)
 * - mobile (600px)
 * - tablet (900px)
 * - desktop (1200px)
 * - wide (1536px)
 * - legacyMobile (0px) - Bootstrap xs
 * - legacyTablet (768px) - Bootstrap sm
 * - legacyDesktop (992px) - Bootstrap md
 * 
 * @example
 * ```tsx
 * <LegacyThemeProvider>
 *   <Box sx={{ 
 *     [theme => theme.breakpoints.up('legacyTablet')]: { p: 4 } 
 *   }}>
 *     Content
 *   </Box>
 * </LegacyThemeProvider>
 * ```
 */
function LegacyThemeProvider({
  children,
  market = "COLLETTE"
}: LegacyThemeProviderProps) {
  return <ThemeProvider theme={getLegacyTheme(market)}>{children}</ThemeProvider>;
}

export default LegacyThemeProvider;